import { Table as TableMui, TableProps as TableMuiProps } from '@mui/material';

export type TableProps = TableMuiProps;

export const Table = TableMui;
